import axios from '../axios/index'
import roleUtil  from "../util/roleUtil"
let myAxios = {
    post(url,param){
        console.log(123)
        axios.post(url,param,roleUtil.fillHeader()).then(resp=>{
            console.log("resp")
            if (this.checkResp(this,resp)){
                return resp
            }
        })
        return null
    },

    postOfNoHeader(url,param){
        axios.post(url,param,null).then(resp=>{
            if (this.$roleUtil.checkResp(resp)){
                return resp
            }
        })
        return null
    },

    checkResp:function (_this,resp){
        if (resp.data.code !== 200){
            _this.$elMeassage({
                showClose: true,
                message: resp.data.data,
                type: 'error',
            })
            return false
        }
        return true
    },

}

export default myAxios

